import { pluginLegendsSelector } from '@/redux/legend/legend.selectors';
import { store } from '@/redux/store';

export const getLegend = (pluginId: string): string[] | undefined => {
  const legend = pluginLegendsSelector(store.getState())[pluginId];

  /** a copy, the stored array is frozen redux state */
  return legend ? [...legend] : undefined;
};
